const linearPreviewHeight = 100;
const circularPreviewHeight = 300;
const bottomPadding = 45;
const paddingLinearEditor = 20;
const paddingOligoEditor = 1;
const minHeightEditorContainer = 300;
const pointerWidth = 2;

export {
    linearPreviewHeight,
    circularPreviewHeight,
    bottomPadding,
    paddingLinearEditor,
    paddingOligoEditor,
    minHeightEditorContainer,
    pointerWidth
}